import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/fonts.css'
import './index.css';
import './assets/styles/styles.scss';
import App from './App';
import Header from './components/header';
import Footer from './components/footer';
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { MeshProvider } from '@meshsdk/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import {ReactComponent as CircleExclamation} from './assets/images/icons/instagram-24px.svg'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MeshProvider>
        <div className='body-container'>
          <Header />
          <App />
          <Footer/>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={3500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="dark"
          closeButton={false}
          style={{ width: 'auto', height: 62, padding: 0}}/>
      </MeshProvider>
    </Provider>
  </React.StrictMode>
);